module.exports = __webpack_public_path__ + "static/media/lo5d_post_B.fe09e117.svg";